<!--
  ~ Copyright (c) 2025 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<div class='checkpoint-card p-3 mb-3'>
  <div class='mb-2'>
    <span class='fw-semibold text-uppercase'>{{ typeTranslationKey() | translate }}</span>
  </div>

  <div class='d-flex flex-column gap-2'>
    @if (checkpoint().namedLocationLabel || location()) {
      <div class='d-flex align-items-center gap-2'>
        <i class='fa-solid fa-location-dot color-gray'></i>
        @if (checkpoint().namedLocationLabel) {
          <span class='fw-medium'>@if (checkpoint().namedLocationCode) {{{ checkpoint().namedLocationCode }} - }{{ checkpoint().namedLocationLabel }}</span>
          @if (location()) {
            <span class='color-gray'>-</span>
          }
        }
        @if (location()) {
          <span>{{ location() }}</span>
        }
      </div>
    }

    @if (checkpoint().timeWindowStart; as twStart) {
      <div class='d-flex align-items-center gap-2'>
        <i class='fa-solid fa-clock color-gray'></i>
        <span class='fw-medium'>{{ twStart.dateTime | wellDate:'YYYY-MM-DD':twStart.timezone }}</span>
        <span class='color-gray'>{{ twStart.dateTime | wellDate:'HH:mm':twStart.timezone }}</span>
        @if (checkpoint().timeWindowEnd; as twEnd) {
          <span> - </span>
          <span class='fw-medium'>{{ twEnd.dateTime | wellDate:'YYYY-MM-DD':twEnd.timezone }}</span>
          <span class='color-gray'>{{ twEnd.dateTime | wellDate:'HH:mm':twEnd.timezone }}</span>
        }
        <span class='color-gray-3 small'>({{ twStart.timezone }})</span>
      </div>
    }

    @if (hasProofOfHandover()) {
      <div class='proof-of-handover-card mt-2'
           [class.completed]='isProofOfHandoverCompleted()'
           [class.refused]='isProofOfHandoverRefused()'
           [class.unavailable]='isProofOfHandoverUnavailable()'>
        <div class='d-flex gap-2'>
          <div class='d-flex flex-column gap-1 flex-grow-1'>
            <div class='d-flex align-items-center gap-2'>
              <i class='fa-solid fa-circle-check'
                 [class.color-success]='isProofOfHandoverCompleted()'
                 [class.color-danger]='isProofOfHandoverRefused()'
                 [class.color-warn]='!isProofOfHandoverCompleted() && !isProofOfHandoverRefused()'></i>
              @if (executedByTypeIcon(); as icon) {
                <i class="fa-solid text-muted" [ngClass]="icon" [pTooltip]="executedByTypeTooltip() | translate" tooltipPosition='left'></i>
              }
              @if (checkpoint().proofOfHandoverExecutedByName) {
                <span>{{ checkpoint().proofOfHandoverExecutedByName }}</span>
                <span class='color-gray'>-</span>
              }
              <span class='fw-medium'>{{ checkpoint().proofOfHandoverDate | wellDate:'yyyy-MM-dd HH:mm' }}</span>
            </div>
            @if (isProofOfHandoverUnavailable()) {
              <div class='d-flex align-items-center gap-2 color-warn'>
                <i class='fa-solid fa-triangle-exclamation'></i>
                <span class='fw-medium'>{{ 'dispatcher.tasks.proofOfHandover.unavailableMessage' | translate }}</span>
              </div>
            }
          </div>
          @if (hasExpandableContent()) {
            <div class='d-flex align-items-center'>
              <i class='fa-solid cursor-pointer'
                 [class.fa-chevron-down]='!expanded()'
                 [class.fa-chevron-up]='expanded()'
                 (click)='toggleExpanded()'></i>
            </div>
          }
        </div>
        @if (expanded()) {
          <div class='d-flex flex-column gap-2 mt-2'>
            @if (proofOfHandoverPersonName()) {
              <div class='d-flex align-items-center gap-2'
                   [pTooltip]="'dispatcher.tasks.proofOfHandover.responsibleName' | translate" tooltipPosition='left'>
                <i class='fa-solid fa-id-card color-gray'></i>
                <span>{{ proofOfHandoverPersonName() }}</span>
              </div>
            }
            @if (checkpoint().proofOfHandoverComment) {
              <div class='d-flex align-items-center gap-2'
                   [pTooltip]="'dispatcher.tasks.proofOfHandover.comment' | translate" tooltipPosition='left'>
                <i class='fa-solid fa-comment color-gray'></i>
                <span>{{ checkpoint().proofOfHandoverComment }}</span>
              </div>
            }
            @if (attachments().length > 0) {
              <div class='mt-2'>
                <div
                  class='section-label fw-medium small color-gray mb-1'>{{ 'delivery-app.utils.attachments' | translate }}
                </div>
                <well-attachment-list [attachments]='attachments()'></well-attachment-list>
              </div>
            }
            @if (signatures().length > 0) {
              <div class='mt-2'>
                <div
                  class='section-label fw-medium small color-gray mb-1'>{{ 'dispatcher.tasks.proofOfHandover.signatures' | translate }}
                </div>
                <well-attachment-list [attachments]='signatures()'></well-attachment-list>
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
</div>
